import { transformActions } from 'utils/';
import { GET_NOTIFICATION } from 'actions/types';

const initialState = {
  data: [],
  isLoading: false,
};

/**
  @description Stores notifications array details in redux state
  @param {[]} state
  @param {{}} action
  @returns {[]}
 */
function notification(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_NOTIFICATION];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (type === GET_NOTIFICATION) {
    return {
      ...state,
      isLoading: true,
    };
  }
  if (success.includes(type)) {
    return {
      data: payload,
      isLoading: false,
    };
  }
  if (failure.includes(type)) {
    return {
      ...state,
      isLoading: false,
    };
  }
  return state;
}

export default notification;
